"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UUID = void 0;
/**
 * 生成UUID
 * @param len UUID的长度
 * radix 进制格式 2、10、16
 */
function UUID(len, radix) {
    if (len === void 0) { len = 32; }
    if (radix === void 0) { radix = 16; }
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = [];
    for (var i = 0; i < len; i++)
        uuid[i] = chars[0 | (Math.random() * radix)];
    return uuid.join('');
}
exports.UUID = UUID;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/shared-utils/dist/common/index.js
// module id = gsKs
// module chunks = 1